/**
 * Reports demo interactions to the backend, so we know how many people go
 * through the demo and where they stop.
 *
 * Uses the real fetch and a same-origin path, since demo mode's network shims
 * would otherwise block this like any other request.
 */
import { getNativeFetch } from './demoMode';

export type DemoEventType =
  | 'tour_started'
  | 'step_viewed'
  | 'tour_completed'
  | 'tour_exited'
  | 'cta_clicked';

const SESSION_KEY = 'rs_demo_session_uid';

// One id per tab for the whole demo, so events group into one visit without
// tracking who the visitor is.
function sessionUid(): string {
  try {
    let uid = sessionStorage.getItem(SESSION_KEY);
    if (!uid) {
      uid = crypto.randomUUID();
      sessionStorage.setItem(SESSION_KEY, uid);
    }
    return uid;
  } catch {
    return 'no-session-storage';
  }
}

export function trackDemoEvent(
  eventType: DemoEventType,
  extra: { stepId?: string; cta?: string } = {},
): void {
  void getNativeFetch()('/gateway/demo/track', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      event_type: eventType,
      session_uid: sessionUid(),
      step_id: extra.stepId,
      meta: extra.cta ? { cta: extra.cta } : undefined,
    }),
  }).catch(() => {}); // a dropped tracking call must never affect the demo
}
